<template><div><p class="d-docsite--paragraph">Typography styles combine multiple typography properties – e.g. <code v-pre>font-family</code>, <code v-pre>font-size</code>, <code v-pre>line-height</code>,<code v-pre>font-weight</code> into a single class. Rather than declare multiple CSS Utilities for each property.</p>
<p class="d-docsite--paragraph">For example, instead of <code v-pre>class=&quot;d-fs-200 d-lh-100&quot;</code> you would declare <code v-pre>class=&quot;d-body--md-compact&quot;</code>.</p>
<dt-notice
  kind="warning"
  :hideClose="true"
  class="d-wmx100p d-mt24"
>
  <template #default>
    <p class="d-body--md-compact"> Typography Styles have been moved to <router-link class="d-fw-semibold d-link d-link--muted" to="/design/typography/">Design Language > Typography</router-link>.</p>
  </template>
</dt-notice>
</div></template>


